import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { RestApi } from '../../../shared/RestApi/restApi';

interface AuditTrailInfo {
  statusMessage: any,
  error: boolean,
  data: any
}
@Injectable({
  providedIn: 'root'
})
export class AuditTrailServiceService {

 
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private Http: HttpClient, private rest: RestApi) { }


  retrieveaudit(){
    return this.Http.get<AuditTrailInfo>(this.rest.RETRIEVE_AUDIT_URL, { headers: this.headers })
  }

 retrieveauditInRange(
    fromDate: string,
    toDate: string,
    language: string,
    user: string = 'allUsers',
    action: string = 'allActions'
  ) {
    const trimmedUser = user?.trim() || 'allUsers';
    const trimmedAction = action?.trim() || 'allActions';

    // Keep sentinel names exact; only real action filters are uppercased (CREATE/UPDATE/DELETE).
    const userParam = encodeURIComponent(
      trimmedUser.toLowerCase() === 'allusers' ? 'allUsers' : trimmedUser
    );
    const actionParam = encodeURIComponent(
      trimmedAction.toLowerCase() === 'allactions'
        ? 'allActions'
        : trimmedAction.toUpperCase()
    );

    return this.Http.get<AuditTrailInfo>(
      `${this.rest.RETRIEVE_AUDIT_URL_IN_Range}/${fromDate}/${toDate}/${language}/${userParam}/${actionParam}`,
      { headers: this.headers }
    );
  }

  retrieveAllUsersByWorkspace(workspaceId){
    return this.Http.get<any>(this.rest.RETRIEVE_ALL_USERS_BY_WORKSPACE+ '/'+workspaceId, { headers: this.headers })
  }
}
